import PropTypes from 'prop-types';
import React from 'react';
import { Expandable } from '@unite-us/app-components';
import { isFocused, INSURANCE } from 'common/utils/isFocused';
import PaymentsInformation from 'src/components/Insurance/PaymentsInformation';
import MilitaryInformation from './MilitaryInformation';

export const SupplementalInformation = ({
  contactId,
  currentGroup,
  submitFailed,
}) => {
  const showHealthInsuranceSection = isFocused(currentGroup, INSURANCE);
  if (!showHealthInsuranceSection) {
    return null;
  }

  return (
    <Expandable
      className="supplemental-information"
      header="Supplemental Information"
    >
      <div className="payments-insurance payments-insurance-form">
        <h3 className="payments-insurance__header">Insurance Information</h3>
        <div className="health-insurance__content">
          <PaymentsInformation contactId={contactId || ''} submitFailed={submitFailed} />
        </div>
      </div>
      <MilitaryInformation />
    </Expandable>
  );
};

SupplementalInformation.propTypes = {
  contactId: PropTypes.string,
  currentGroup: PropTypes.object.isRequired,
  submitFailed: PropTypes.bool,
};

SupplementalInformation.defaultProps = {
  contactId: '',
  submitFailed: false,
};

export default SupplementalInformation;
